import { z } from 'zod';

export const VoteDecision = z.enum(['yes', 'maybe', 'no']);
export type VoteDecision = z.infer<typeof VoteDecision>;

/** A vote is always cast by a human participant — `system` is never a voter. */
export const VoterRole = z.enum(['coordinator', 'vendor', 'operator']);
export type VoterRole = z.infer<typeof VoterRole>;

export const AppointmentMessageVote = z.object({
  id: z.string().uuid(),
  messageId: z.string().uuid(),
  voterUserId: z.string().uuid(),
  /** Server-set at vote-cast time from participation resolution. Required for AutoBook tally. */
  voterRole: VoterRole,
  candidateIndex: z.number().int().min(0).max(7),
  decision: VoteDecision,
  note: z.string().max(140).optional(),
  votedAt: z.string().datetime(),
});
export type AppointmentMessageVote = z.infer<typeof AppointmentMessageVote>;

export const CastVoteInput = z.object({
  candidateIndex: z.number().int().min(0).max(7),
  decision: VoteDecision,
  note: z.string().max(140).optional(),
});
export type CastVoteInput = z.infer<typeof CastVoteInput>;
